import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { BackofficeUnansweredQuestionTopicsResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof BackofficeUnansweredQuestionTopicsResponseDataSchema>>

export const getBackofficeUnansweredQuestionTopicsQuery = (companyId: string | undefined) =>
  queryOptions({
    queryKey: ["backofficeUnansweredQuestionTopics", companyId],
    placeholderData: () => undefined,
    queryFn: async ({ signal }) => {
      const { data } = await axios.get<Response>("/backoffice/knowledge/unanswered-topics", {
        params: { companyId },
        signal,
      })
      return data.data
    },
  })
